import { store } from '@/store'
import DynamicModuleRegistrationUtil from '@/utils/dynamicModuleRegistration'
import { BaseRouteEnum, ProductBadgingEnum } from '@/enums/modules/routes'

// Vuex Modules to load
const ProductBadgingModule = () => import(/* webpackChunkName: "ProductBadging" */ '../store/modules/productBadging')

// Components
const ProductBadging = () =>
  import(/* webpackChunkName: "ProductBadging" */ '@/components/productBadging/ProductBadging')
const ProductBadgingHome = () =>
  import(/* webpackChunkName: "ProductBadgingDetails" */ '@/components/productBadging/home/ProductBadgingHome')
const ProductBadgingDetails = () =>
  import(/* webpackChunkName: "ProductBadgingDetails" */ '@/components/productBadging/edit/ProductBadgingDetails')

const dynamicModuleRegistrationReturnsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'productBadging',
    module: ProductBadgingModule,
    store,
    modulePath: 'productBadging'
  }
}

export default [
  {
    path: '/2DayShippingBadges',
    component: ProductBadging,
    name: ProductBadgingEnum.ProductBadging,
    beforeEnter (_to, _from, next) {
      // if a subaccount user of a powered by account tries to load product badging information
      // redirect them to the Dashboard instead
      const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
      if (isPoweredBySubAccountUser) {
        next({ name: BaseRouteEnum.DashboardV2 })
      } else {
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationReturnsArgs()).then(() => next())
      }
    },
    meta: { showSideNav: true },
    children: [
      {
        path: '',
        name: ProductBadgingEnum.ProductBadgingHome,
        component: ProductBadgingHome,
        meta: { showSideNav: true }
      },
      {
        path: 'Edit/:id?',
        name: ProductBadgingEnum.ProductBadgingEdit,
        component: ProductBadgingDetails,
        meta: { showSideNav: true }
      }
    ]
  }
]
